export const quickNavItems = [
  {
    id: 'reliability',
    icon: 'ri-shield-check-line',
    title: '神马影院靠谱吗',
    desc: '从站点性质、内容来源、运营稳定性等维度，拆解它到底靠不靠谱。',
    tone: 'primary',
  },
  {
    id: 'safety',
    icon: 'ri-alarm-warning-line',
    title: '神马影院安全吗',
    desc: '弹窗、跳转、诱导下载、隐私索取……逐条梳理常见安全隐患。',
    tone: 'accent',
  },
  {
    id: 'virus',
    icon: 'ri-bug-2-line',
    title: '有病毒吗',
    desc: '“看个电影会不会中毒”？说清风险到底来自网页还是安装包。',
    tone: 'secondary',
  },
  {
    id: 'authenticity',
    icon: 'ri-question-mark',
    title: '是不是假的',
    desc: '域名频繁更换、克隆站、仿冒客服，教你怎么判断真假。',
    tone: 'primary',
  },
  {
    id: 'feedback',
    icon: 'ri-chat-smile-2-line',
    title: '用户口碑评价',
    desc: '汇总体验、广告、安全、内容等不同角度的真实感受反馈。',
    tone: 'accent',
  },
  {
    id: 'risks',
    icon: 'ri-error-warning-line',
    title: '风险点与建议',
    desc: '一张风险清单 + 一份可执行的使用建议，帮你少踩坑。',
    tone: 'secondary',
  },
];

export const aboutPoints = [
  {
    icon: 'ri-film-line',
    title: '本质是第三方影视聚合站',
    desc: '“神马影院”一般指以在线影视播放为卖点、非官方出品的第三方影视网站或同名 App，片源多为聚合或抓取，并非正规版权平台。',
  },
  {
    icon: 'ri-refresh-line',
    title: '域名与入口经常变化',
    desc: '这类站点为了规避封禁，域名、备用地址和 App 下载入口时常变动，今天能打开的链接，过几天可能就失效或被替换。',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: '盈利主要靠广告',
    desc: '大多通过弹窗、贴片、导流和会员充值变现，这也是页面广告多、跳转频繁、容易引导下载的主要原因。',
  },
  {
    icon: 'ri-user-voice-line',
    title: '口碑两极且信息混乱',
    desc: '网上既有“免费能看”的正面评价，也有“广告多、套路深”的吐槽，同名站点众多，很难用一句话概括好坏。',
  },
];

export const reliabilityDimensions = [
  { label: '站点正规性', value: '偏低', score: 35, note: '通常无正规备案与版权资质，属第三方聚合。' },
  { label: '内容来源', value: '不透明', score: 40, note: '片源多为聚合抓取，来源与清晰度不稳定。' },
  { label: '运营稳定性', value: '一般', score: 50, note: '站点常换域名，长期可用性难以保证。' },
  { label: '访问体验', value: '中等', score: 55, note: '可看但广告、跳转较多，体验因时段而异。' },
  { label: '付费可靠性', value: '谨慎', score: 30, note: '充值、会员类付款缺少正规售后与凭证。' },
  { label: '隐私保护', value: '较弱', score: 32, note: '对个人信息处理缺乏透明说明与保障。' },
];

export const safetyRisks = [
  {
    icon: 'ri-external-link-line',
    title: '自动跳转与劫持',
    desc: '点击播放或任意位置都可能被跳转到站外页面、推广页甚至仿冒登录页，误点后不易返回。',
    level: '高',
    tone: 'primary',
  },
  {
    icon: 'ri-download-2-line',
    title: '诱导下载安装包',
    desc: '反复提示“需下载客户端才能播放”，而下发的安装包往往来源不明，是病毒与捆绑软件的主要入口。',
    level: '高',
    tone: 'primary',
  },
  {
    icon: 'ri-window-line',
    title: '密集弹窗广告',
    desc: '弹窗、浮层、贴片广告频繁出现，部分广告内容本身就可能指向高风险页面。',
    level: '中',
    tone: 'secondary',
  },
  {
    icon: 'ri-lock-unlock-line',
    title: '钓鱼与虚假充值',
    desc: '可能出现仿冒的支付页、客服或“激活码”，诱导付款后无法追回，也拿不到有效服务。',
    level: '高',
    tone: 'primary',
  },
  {
    icon: 'ri-user-follow-line',
    title: '过度索取权限',
    desc: '同名 App 可能索要通讯录、短信、定位等与观影无关的权限，存在信息被收集滥用的风险。',
    level: '中',
    tone: 'secondary',
  },
  {
    icon: 'ri-scales-3-line',
    title: '版权与法律风险',
    desc: '片源未获授权，观看和传播盗版内容在部分地区可能涉及版权问题，需自行留意合规边界。',
    level: '中',
    tone: 'accent',
  },
];

export const virusAnalysis = [
  {
    icon: 'ri-global-line',
    title: '风险不在“网页本身”',
    desc: '单纯用浏览器打开页面，通常不会直接让设备中毒。真正的问题是页面里的跳转、脚本和诱导点击。',
    tone: 'accent',
  },
  {
    icon: 'ri-smartphone-line',
    title: '风险集中在 App 与安装包',
    desc: '一旦按提示下载并安装来路不明的客户端，木马、捆绑推广、后台扣费的风险会显著上升。',
    tone: 'primary',
  },
  {
    icon: 'ri-computer-line',
    title: '浏览器插件与“解码器”套路',
    desc: '以“安装专用播放器/解码器”为名的插件或程序，常带有捆绑与劫持行为，需高度警惕。',
    tone: 'primary',
  },
  {
    icon: 'ri-shield-keyhole-line',
    title: '权限与账号是重灾区',
    desc: '若要求登录、授权不受控权限或输入账号密码，风险会从“内容”升级到“信息与财产”。',
    tone: 'secondary',
  },
];

export const authenticityChecks = [
  '同一名称出现大量不同域名、不同界面，且相互之间无法互相跳转。',
  '页面几乎不提供公司主体、备案信息或可核实的运营方联系方式。',
  '域名中含大量随机字符、频繁更换，或与名称明显不对应。',
  '站内出现仿冒客服、假“官方群”、假“激活码”等诱导信息。',
  '以“限时免费”“内部片源”为噱头，催促你尽快下载或付款。',
  '登录或支付页面与站内风格明显不一致，地址栏域名对不上。',
];

export const feedbackItems = [
  {
    id: 1,
    tag: '内容',
    name: '匿名用户 A',
    initial: 'A',
    rating: 3,
    text: '片源更新还算快，热门剧基本能找到，但清晰度参差，有的集数会突然换个字幕组，看着有点跳。',
  },
  {
    id: 2,
    tag: '广告',
    name: '匿名用户 B',
    initial: 'B',
    rating: 2,
    text: '广告是真的多，点一下暂停能弹两次窗，手机上尤其烦，一不小心就跳到下载页去了。',
  },
  {
    id: 3,
    tag: '安全',
    name: '匿名用户 C',
    initial: 'C',
    rating: 1,
    text: '被提示要下客户端才能看高清，装完之后浏览器主页被改了，卸载也麻烦，感觉不太干净。',
  },
  {
    id: 4,
    tag: '体验',
    name: '匿名用户 D',
    initial: 'D',
    rating: 3,
    text: '网页版偶尔能直接用，播放不卡的时候还行，但地址老是变，收藏的链接过段时间就打不开了。',
  },
  {
    id: 5,
    tag: '内容',
    name: '匿名用户 E',
    initial: 'E',
    rating: 4,
    text: '免费这一点没得说，能看的片子挺全。就是别指望有多高清，也别点那些花里胡哨的按钮。',
  },
  {
    id: 6,
    tag: '安全',
    name: '匿名用户 F',
    initial: 'F',
    rating: 2,
    text: '有次点播放直接跳到仿冒的登录页让我输账号，感觉是钓鱼，赶紧关了，之后就不太敢用了。',
  },
  {
    id: 7,
    tag: '广告',
    name: '匿名用户 G',
    initial: 'G',
    rating: 2,
    text: '说是免费，结果到处引导开会员，弹窗广告跟会员推广混在一起，分不清哪个是真的。',
  },
  {
    id: 8,
    tag: '体验',
    name: '匿名用户 H',
    initial: 'H',
    rating: 4,
    text: '当个临时应急的备用站还行，要求不高的话能凑合看。长期用我还是更愿意选正规平台。',
  },
];

export const riskChecklist = [
  '被反复提示“需下载客户端/播放器”才能播放，且安装包来源不明。',
  '播放或点击任意区域都被强制跳转到站外推广页面。',
  '出现让你输入账号密码、支付信息或验证码的页面。',
  '以“激活码”“内部片源”“限时优惠”为由催促你尽快付款。',
  'App 索要通讯录、短信、定位等与观影无关的权限。',
  '浏览器主页、默认搜索或书签被莫名修改。',
  '设备出现异常发热、流量激增或后台有未知程序运行。',
];

export const usageTips = [
  {
    no: '01',
    title: '只用浏览器，不装任何客户端',
    desc: '坚持在浏览器里观看，拒绝一切“必须下载 App 才能播放”的提示，这是规避病毒风险最关键的一条。',
  },
  {
    no: '02',
    title: '不开权限、不登录、不付款',
    desc: '不授予与观影无关的权限，不在站内登录重要账号，更不要为“激活码”或“会员”付款。',
  },
  {
    no: '03',
    title: '给浏览器装上广告与脚本拦截',
    desc: '使用可靠的安全软件和拦截插件，能显著减少弹窗、跳转和恶意脚本带来的骚扰与风险。',
  },
  {
    no: '04',
    title: '核对网址，警惕仿冒页面',
    desc: '登录、支付类页面前先看地址栏域名是否与主站一致，任何不一致都立即关闭。',
  },
  {
    no: '05',
    title: '优先选择正规影视平台',
    desc: '有稳定付费能力时，正规平台的片源、清晰度和账号安全都更有保障，长期看更省心。',
  },
  {
    no: '06',
    title: '重要设备上尽量避免访问',
    desc: '存有重要资料或用于工作的设备，尽量不要打开来源不明的影视站，降低潜在损失。',
  },
];

export const faqs = [
  {
    q: '神马影院到底靠谱吗？',
    a: '从公开信息看，它通常属于没有正规资质与版权来源的第三方影视聚合站，稳定性、内容合法性和售后都缺乏保障，因此整体可靠性偏低。能否使用取决于你对风险与便利的权衡，建议保持谨慎。',
  },
  {
    q: '神马影院安全吗，会不会有病毒？',
    a: '单纯用浏览器浏览一般不会直接中毒，风险主要来自站内的跳转、弹窗以及诱导下载的 App 和“播放器/解码器”安装包。只要不下载安装、不授予权限、不登录付款，风险可以明显降低。',
  },
  {
    q: '神马影院是不是假的？',
    a: '“神马影院”这个名称下存在大量同名、不同域名的站点和 App，彼此之间缺乏统一的运营主体，其中既有聚合站，也可能有借用名称的克隆站或仿冒站。判断真假的关键是核对域名、资质与页面一致性，而不是只认名字。',
  },
  {
    q: '为什么它的地址经常打不开或换域名？',
    a: '这类站点为规避封禁和监管，常准备多个备用域名并不断更换，导致原链接失效、搜索结果里出现大量“新地址”。频繁换域名本身也是可靠性偏低的一个信号。',
  },
  {
    q: '在上面充值会员有保障吗？',
    a: '通常没有。第三方站点的付费往往缺少正规合同、发票与售后，一旦站点关闭或换域名，已付款项很难追回。是否为充值行为，建议格外谨慎。',
  },
  {
    q: '有没有更稳妥的替代选择？',
    a: '如果只是偶尔想看片，可以优先考虑有正版授权的正规影视平台，或使用公共图书馆、电视台官方客户端等免费且合规的渠道。它们的内容来源和账号安全都更有保障。',
  },
];

export const summaryStats = [
  { value: '6', label: '可靠性评估维度' },
  { value: '6', label: '典型安全风险点' },
  { value: '7', label: '自检风险清单' },
  { value: '6', label: '安全使用建议' },
];